import React, { useState } from 'react';
import 'react-image-lightbox/style.css';
import i18n from 'i18n-js';
import { useStyles } from './Images.styled';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import Lightbox from 'react-image-lightbox';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';

const FormsImages = ({ images, event, width }) => {
  const classes = useStyles();
  const [lightboxProperties, setLightboxProperties] = useState({
    isOpen: false,
  });

  /**
   * Get grid list cols
   */
  const getGridListCols = () => {
    if (isWidthUp('xl', width)) {
      return 4;
    }

    if (isWidthUp('lg', width)) {
      return 4;
    }

    if (isWidthUp('md', width)) {
      return 3;
    }

    return 2;
  };

  return (
    <div>
      <div>
        <label className={classes.label}>{event.label}:</label>{' '}
        <span className={classes.value}>{event.response}</span>
      </div>
      <div className={classes.divider}></div>
      <GridList spacing={8} cellHeight={100} className={classes.gridList} cols={getGridListCols()}>
        {images.map((item, index) => (
          <GridListTile
            classes={{ imgFullHeight: classes.images }}
            className={classes.imagesEvent}
            key={item.id}
            cols={1}
          >
            <img
              alt={item?.display_name || ''}
              src={item?.reference_url}
              onClick={() => {
                setLightboxProperties({
                  isOpen: true,
                  photoIndex: index,
                });
              }}
            />
            <span className={classes.value}>
              {item?.response
                ? i18n.t(`forms.${item?.response}`, { defaultValue: item?.response })
                : ''}
            </span>
          </GridListTile>
        ))}
      </GridList>
      {lightboxProperties.isOpen && (
        <div>
          <Lightbox
            mainSrc={images[lightboxProperties.photoIndex]?.reference_url}
            nextSrc={images[(lightboxProperties.photoIndex + 1) % images.length]?.reference_url}
            prevSrc={
              images[(lightboxProperties.photoIndex + images.length - 1) % images.length]
                ?.reference_url
            }
            onCloseRequest={() =>
              setLightboxProperties({
                isOpen: false,
              })
            }
            onMovePrevRequest={() =>
              setLightboxProperties({
                ...lightboxProperties,
                photoIndex: (lightboxProperties.photoIndex + images.length - 1) % images.length,
              })
            }
            onMoveNextRequest={() =>
              setLightboxProperties({
                isOpen: true,
                photoIndex: (lightboxProperties.photoIndex + 1) % images.length,
              })
            }
            reactModalStyle={{
              overlay: {
                zIndex: '1300',
              },
            }}
          />
        </div>
      )}
    </div>
  );
};

export default withWidth()(FormsImages);
